import React, { useEffect } from "react";
import { compose } from "redux";

import refAFriendConnector from "../../../services/referAFriend/connector";
import TableNew from "../../../shared/Table";
import { TableCellAccountRedirect } from "../../../shared/Table/components/Cell";
import CreateCampaign from "./AddCampaign.Component";
import SingleCampaign from "./SingleCampaign.Component";
import moment from "moment";

const ReferAFriend = ({
  referAFriend,
  getCampaigns,
  getReferred,
  updateStartDate,
  updateEndDate,
  addCampaign,
}) => {
  const {
    referred: { data },
  } = referAFriend;

  useEffect(() => {
    getReferred();
    getCampaigns();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      key: "CampaignName",
      label: "Campaign Name",
      visible: true,
      filter: true,
    },
    {
      key: "InvestorOwnerSsn",
      label: "Investor Owner SSN",
      visible: true,
      renderer: (value) => {
        return <TableCellAccountRedirect value={value} type={"ssn"} />;
      },
    },
    {
      key: "BonusOrderStatus",
      label: "Bonus order status",
      visible: true,
      filter: false,
      renderer: (value) => {
        return <span>{value ? value : "Not set"}</span>;
      },
    },
    {
      key: "BonusOrderAmount",
      label: "Bonus order amount ",
      visible: true,
      filter: false,
    },
    { key: "Created", label: "Created date", visible: true, filter: false },
  ];

  return (
    <React.Fragment>
      <div style={{ margin: "50px" }}>
        <CreateCampaign {...{ addCampaign, moment }} />
        <Campaigns
          {...{
            referAFriend,
            getCampaigns,
            getReferred,
            updateStartDate,
            updateEndDate,
          }}
        />
      </div>
      <div style={{ margin: "10px" }}>
        <TableNew
          columns={columns}
          tableKey={"smth"}
          selectId={"Id"}
          items={data}
          actionColumnWidth={190}
        />
      </div>
    </React.Fragment>
  );
};

const Campaigns = ({
  referAFriend: { campaign },
  updateEndDate,
  updateStartDate,
}) => {
  return (
    <React.Fragment>
      <div style={{ padding: "20px 0" }}>
        <h3>Campaigns</h3>
      </div>
      <div className="row">
        {campaign.data.length !== 0
          ? campaign.data.map((item) => (
              // eslint-disable-next-line react/jsx-key
              <SingleCampaign
                {...{
                  item,
                  updateEndDate,
                  updateStartDate,
                }}
              />
            ))
          : undefined}
      </div>
    </React.Fragment>
  );
};

export default compose(refAFriendConnector)(ReferAFriend);
